import React, { useState } from 'react';
import { Button } from '../components/ui/Button';
import { Input } from '../components/ui/Input';
import { Spinner } from '../components/ui/Spinner';
import { PAGE_ROUTE } from '../lib/routes';
import { MailIcon } from 'lucide-react';
interface ResetPasswordProps {
  navigate: (page: string, context?: any) => void;
}
export function ResetPassword({
  navigate
}: ResetPasswordProps) {
  const [email, setEmail] = useState('');
  const [loading, setLoading] = useState(false);
  const [sent, setSent] = useState(false);
  const [error, setError] = useState('');
  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setLoading(true);
    setError('');
    try {
      await new Promise(resolve => setTimeout(resolve, 1000));
      setSent(true);
    } catch {
      setError('A apărut o eroare. Te rugăm să încerci din nou.');
    } finally {
      setLoading(false);
    }
  };
  if (sent) {
    return <div className="w-full max-w-md mx-auto px-4 py-12" data-id="element-3957">
        <div className="rounded-2xl border border-dark-4 bg-dark-2/50 p-6 sm:p-8 text-center" data-id="element-3958">
          <div className="w-12 h-12 rounded-full bg-lime-500/10 flex items-center justify-center mx-auto mb-4" data-id="element-3959">
            <MailIcon className="w-6 h-6 text-lime-400" data-id="element-3960" />
          </div>
          <h1 className="text-xl font-bold text-light-1 mb-2" data-id="element-3961">
            Verifică-ți email-ul
          </h1>
          <p className="text-sm text-light-3 mb-6" data-id="element-3962">
            Dacă există un cont cu acest email, vei primi un link de resetare a
            parolei.
          </p>
          <button onClick={() => navigate(PAGE_ROUTE.LOGIN)} className="w-full" data-id="element-3963">
            <Button variant="outline" className="w-full" data-id="element-3964">
              Înapoi la autentificare
            </Button>
          </button>
        </div>
      </div>;
  }
  return <div className="w-full max-w-md mx-auto px-4 py-12" data-id="element-3965">
      <div className="text-center mb-8" data-id="element-3966">
        <h1 className="text-2xl font-bold text-light-1" data-id="element-3967">Resetare parolă</h1>
        <p className="text-sm text-light-3 mt-2" data-id="element-3968">
          Introdu email-ul contului tău și îți vom trimite un link de resetare.
        </p>
      </div>

      <div className="rounded-2xl border border-dark-4 bg-dark-2/50 p-6 sm:p-8" data-id="element-3969">
        <form onSubmit={handleSubmit} className="space-y-4" data-id="element-3970">
          {error && <div className="p-3 rounded-lg bg-red-4 border border-red-2 text-red-1 text-sm" data-id="element-3971">
              {error}
            </div>}

          <div className="space-y-1.5" data-id="element-3972">
            <label htmlFor="reset-email" className="block text-sm font-medium text-light-2" data-id="element-3973">
              Email
            </label>
            <Input id="reset-email" type="email" value={email} onChange={e => setEmail(e.target.value)} placeholder="email@exemplu.ro" required autoComplete="email" data-id="element-3974" />
          </div>

          <Button type="submit" disabled={loading} className="w-full bg-primary text-primary-foreground hover:bg-lime-2" size="lg" data-id="element-3975">
            {loading ? <span className="flex items-center gap-2" data-id="element-3976">
                <Spinner size="sm" data-id="element-3977" />
                Se trimite...
              </span> : 'Trimite link de resetare'}
          </Button>
        </form>

        <p className="text-center text-sm text-light-4 mt-4" data-id="element-3978">
          <button onClick={() => navigate(PAGE_ROUTE.LOGIN)} className="font-medium text-lime-1 hover:text-lime-2" data-id="element-3979">
            Înapoi la autentificare
          </button>
        </p>
      </div>
    </div>;
}